/**
 * IntegrationCallback — legacy OAuth-popup landing route, now inert.
 *
 * The OAuth popup is gone. Connect is a same-window redirect that returns to the
 * in-app page with integration_connected / calendar_connected, which
 * App.tsx's OAuth-return handler consumes. No connect targets /integrations/callback
 * anymore (connectProvider always sends an in-app redirectUrl), so this route is
 * unreachable in practice — kept as a harmless no-op. The route registration can be
 * removed in a follow-up.
 */

export function IntegrationCallback() {
  return null;
}
